import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import AssetsDashboard from '../AssetsDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import AssetsPageImpl from './AssetsPageImpl';

export default function AssetsPage() {
    const {mobileView} = useSelector((state) => state.menu);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':!mobileView}));
    },[]);

    return (
        < AssetsPageImpl />
    )

}